import React, { useState } from 'react';

const Tips = ({ title = "Tips", icon = "fa-lightbulb", tips = [], accentColor = 'purple' }) => {
  const [activeTip, setActiveTip] = useState(null);

  // Dynamically construct Tailwind classes using the accentColor
  const accentTextClass = `text-accent-${accentColor}`;
  const accentBgClass = `bg-accent-${accentColor}`;
  const accentHoverBorderClass = `hover:border-accent-${accentColor}/30`;
  const accentFocusRingClass = `focus:ring-accent-${accentColor}/50`;
  const accentBorderClass = `border-accent-${accentColor}/30`;
  const accentHoverTextClass = `group-hover:text-accent-${accentColor}`;
  const accentHoverBgClass = `hover:bg-accent-${accentColor}/30`;

  // Define the glow color based on accentColor
  const glowColorFrom = `from-accent-${accentColor}/15`; // Adjust opacity as needed
  const glowColorVia = `via-accent-${accentColor}/5`;   // Adjust opacity as needed

  return (
    // --- MODIFIED: Added 'group' for hover effects on children ---
    <div className={`bg-dark-600 rounded-2xl p-6 transition-medium border border-dark-400 ${accentHoverBorderClass} overflow-hidden relative group`}>
    {/* --- NEW: Pseudo-element for Glow --- */}
    <div
      className={`
        content-none absolute inset-0 z-0 rounded-2xl
        bg-gradient-radial ${glowColorFrom} ${glowColorVia} to-transparent
        opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out
        blur-lg pointer-events-none
      `}
    ></div>

    {/* --- NEW: Inner wrapper for content scaling --- */}
    <div className="relative z-10 transition-transform duration-300 ease-in-out group-hover:scale-[1.005]">
        <h3 className="font-bold text-lg mb-4 flex items-center">
            {/* Icon container */}
            <div className={`w-10 h-10 rounded-lg ${accentBgClass}/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium`}>
                <i className={`fas ${icon} ${accentTextClass}`}></i>
            </div>
            {title}
            {/* Optional Badge */}
            <div className={`ml-3 text-xs py-1 px-2 ${accentBgClass}/20 rounded-full ${accentTextClass} opacity-0 group-hover:opacity-100 transition-medium`}>
                Pro Tips
            </div>
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {tips.map((tip, index) => (
                <div
                    key={index}
                    // Removed transform-gpu here, applied to inner elements if needed
                    className={`bg-dark-500 rounded-xl p-4 border border-transparent transition-medium cursor-pointer ${activeTip === index
                            ? `${accentBorderClass} scale-[1.03] shadow-md` // Internal scale is fine
                            : 'hover:border-dark-300 hover:-translate-y-0.5' // Internal hover is fine
                        }`}
                    onClick={() => setActiveTip(activeTip === index ? null : index)}
                    onMouseEnter={() => setActiveTip(index)}
                    onMouseLeave={() => setActiveTip(null)}
                >
                    <div className="flex items-start mb-2">
                        <div className={`w-8 h-8 rounded-lg ${accentBgClass}/20 flex items-center justify-center mr-3 mt-0.5 transition-medium transform-gpu ${activeTip === index ? 'scale-110 rotate-12' : ''
                            }`}>
                            <i className={`fas ${tip.icon} ${accentTextClass} text-sm`}></i>
                        </div>
                        <div>
                            <h4 className={`font-semibold text-sm ${accentHoverTextClass} transition-medium`}>
                                {tip.title}
                            </h4>
                            <p className="text-xs text-gray-400 mt-1 group-hover:text-gray-300 transition-medium">
                                {tip.description}
                            </p>
                        </div>
                    </div>

                    {/* Expanded details */}
                    {activeTip === index && tip.details && (
                        <div className="mt-2 pt-2 border-t border-dark-400 text-xs text-gray-400 animate-fade-in">
                            <p>{tip.details}</p>
                        </div>
                    )}

                    {/* Indicator dot */}
                    <div className={`absolute bottom-3 right-3 w-2 h-2 rounded-full ${accentBgClass} transition-all duration-300 ${activeTip === index ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
                        }`}></div>
                </div>
            ))}
        </div>

         {/* Optional Footer */}
        {<div className="mt-6 text-center">
            <p className="text-sm text-gray-400 mb-3 hover:text-gray-300 transition-medium">
                Remember to use this tool responsibly.
            </p>
        </div> }
    {/* --- End Inner wrapper --- */}
    </div>

    {/* Background glow effects (can be removed if pseudo-element is sufficient) */}
    {/* <div className={`absolute -right-10 -top-10 w-32 h-32 ${accentBgClass} opacity-5 rounded-full blur-xl`}></div> */}
    {/* <div className={`absolute -left-10 -bottom-10 w-32 h-32 ${accentBgClass} opacity-5 rounded-full blur-xl`}></div> */}

</div>
  );
};
export default Tips;